const ProductList = {
  "options": {
    "data": {
      "text": {
        "type": "Text",
        "order": 1
      },
      "images": [
        {
          "image": {
            "src": ""
          },
          "pointTo": {
            "url": "",
            "pointTo": "",
            "pointToName": "",
            "pointToType": ""
          }
        }
      ]
    },
    "customization": {
      "textSize": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 2
      },
      "textColor": {
        "type": "HexColor",
        "order": 3
      },
      "textAlignment": {
        "type": "LeftCenterRight",
        "order": 4
      },
      "textStyle": {
        "type": "SelectBox",
        "data": {
          "selectOptions": ["normal", "italic"]
        },
        "order": 5
      },
      "textWeight": {
        "type": "SelectBox",
        "data": {
          "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
        },
        "order": 6
      },
      "textLetterSpacing": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 7
      },
      "backgroundSize": {
        "type": "Radio",
        "order": 10,
        "data": {
          "direction": "row",
          "radioOptions": ["cover", "contain", "stretch"]
        }
      },
      "boxShadow": {
        "type": "ChildComponentRenderer",
        "order": 12,
        "data": {
          "componentNames": ["shadow1", "shadow2", "shadow3"]
        }
      }
    },
    "widgets": {
      "Tabs_1": {
        "type": "Tabs",
        "order": 8,
        "options": {
          "containerPadding": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "edge"
            },
            "type": "FourPx"
          },
          "padding": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "edge"
            },
            "type": "FourPx"
          },
          "borderRadius": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "border"
            },
            "type": "FourPx"
          }
        }
      },
      "Menu_1": {
        "type": "Menu",
        "order": 11,
        "renderOptions": {
          "controlKey": "productFeatures"
        },
        "options": {
          "productTextControl": {
            "data": {
              "direction": "row",
              "radioOptions": ["clip", "wrap"]
            },
            "type": "Radio"
          },
          "productTextColor": {
            "type": "HexColor"
          },
          "productBorderColor": {
            "type": "HexColor"
          },
          "productTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            }
          },
          "productPriceTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            }
          },
          "iconTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            }
          },
          "productPriceWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            }
          },
          "productPriceColor": {
            "type": "HexColor"
          },
          "widget.ProductGrid.productBackgroundType": {
            "type": "ToggleRadioTabs",
            "renderOptions": {
              "controlKey": "productBackgroundType",
              "direction": "row"
            },
            "options": {
              "productBackgroundImage": {
                "type": "ImageUploader"
              },
              "productBackgroundColor": {
                "type": "HexColor"
              }
            }
          },
          "widget.ProductGrid.productIcons": {
            "type": "Group",
            "renderOptions": {
              "controlKey": "productIcons"
            },
            "options": {
              "widget.ToggleTabs_1": {
                "type": "ToggleTabs",
                "order": 5,
                "renderOptions": {
                  "controlKey": "isHeartIcon"
                },
                "options": {
                  "heartIcon": {
                    "type": "IconSelector",
                    "data": {
                      "defaultIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png"
                    },
                    "order": 1
                  },
                  "heartIconBackgroundColor": {
                    "type": "HexColor",
                    "order": 6
                  },
                  "heartIconColor": {
                    "type": "HexColor",
                    "order": 7
                  },
                  "selectedHeartIconColor": {
                    "type": "HexColor",
                    "order": 7
                  },
                  "heartIconWidth": {
                    "data": {
                      "max": 40,
                      "min": 20,
                      "step": 1
                    },
                    "type": "RangePx"
                  }
                }
              },
              "widget.ToggleTabs_2": {
                "type": "ToggleTabs",
                "order": 5,
                "renderOptions": {
                  "controlKey": "isCartIcon"
                },
                "options": {
                  "cartIcon": {
                    "type": "IconSelector",
                    "data": {
                      "defaultIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png"
                    },
                    "order": 1
                  },
                  "cartIconBackgroundColor": {
                    "type": "HexColor",
                    "order": 6
                  },
                  "cartIconColor": {
                    "type": "HexColor",
                    "order": 7
                  },
                  "cartIconWidth": {
                    "data": {
                      "max": 40,
                      "min": 20,
                      "step": 1
                    },
                    "type": "RangePx"
                  }
                }
              },
              "widget.ToggleTabs_3": {
                "type": "ToggleTabs",
                "order": 5,
                "renderOptions": {
                  "controlKey": "isDiscountIcon"
                },
                "options": {
                  "discountIcon": {
                    "type": "IconSelector",
                    "data": {
                      "defaultIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png"
                    },
                    "order": 1
                  },
                  "discountIconBackgroundColor": {
                    "type": "HexColor",
                    "order": 6
                  },
                  "discountIconColor": {
                    "type": "HexColor",
                    "order": 7
                  },
                  "discountIconWidth": {
                    "data": {
                      "max": 40,
                      "min": 0,
                      "step": 1
                    },
                    "type": "RangePx"
                  }
                }
              }
            }
          },
          "productIconColor": {
            "type": "HexColor"
          },
          "productImagePadding": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "edge"
            },
            "type": "FourPx"
          },
          "productImageBorderRadius": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "border"
            },
            "type": "FourPx"
          },
          "productImageHeight": {
            "data": {
              "max": 300,
              "min": 80,
              "step": 1
            },
            "type": "RangePx"
          }
        }
      },
      "ToggleRadioTabs_1": {
        "type": "ToggleRadioTabs",
        "order": 9,
        "renderOptions": {
          "controlKey": "backgroundType",
          "direction": "row"
        },
        "options": {
          "backgroundImage": {
            "type": "ImageUploader"
          },
          "backgroundColor": {
            "type": "HexColor"
          }
        }
      }
    }
  },
  "variants": [
    {
      "id": "ProductList_1",
      "name": "ProductList_1",
      "type": "ProductList",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "borderRadius": "0px 0px 0px 0px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "productTextControl": "clip",
        "productTextWeight": "400",
        "productTextColor": "#7059ef",
        "productTextSize": "9px",
        "productBackgroundColor": "#F0EEFB",
        "productImagePadding": "0px 0px 0px 0px",
        "productImageBorderRadius": "0px 0px 0px 0px",
        "productImageHeight": "110px",
        "productBackgroundImage": "",
        "productBackgroundType": "-",
        "productBorderColor": "#7059ef",
        "productPriceTextSize": "10px",
        "productPriceWeight": "400",
        "productPriceColor": "#000000",
        "isHeartIcon": false,
        "heartIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
        "heartIconBackgroundColor": "#F0EEFB",
        "heartIconColor": "#F0EEFB",
        "selectedHeartIconColor": "#ff0000",
        "heartIconWidth": "20px",
        "isDiscountIcon": false,
        "discountIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
        "discountIconBackgroundColor": "#F0EEFB",
        "discountIconColor": "#F0EEFB",
        "discountIconWidth": "20px",
        "isCartIcon": false,
        "cartIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
        "cartIconBackgroundColor": "#F0EEFB",
        "cartIconColor": "#F0EEFB",
        "cartIconWidth": "20px",
        "iconTextSize": "10px"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Product_List_1.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "ProductList_2",
      "name": "ProductList_2",
      "type": "ProductList",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "borderRadius": "0px 0px 0px 0px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "productTextControl": "clip",
        "productTextWeight": "400",
        "productTextColor": "#7059ef",
        "productTextSize": "9px",
        "productBackgroundColor": "#F0EEFB",
        "productImagePadding": "0px 0px 0px 0px",
        "productImageBorderRadius": "0px 0px 0px 0px",
        "productImageHeight": "110px",
        "productBackgroundImage": "",
        "productBackgroundType": "-",
        "productBorderColor": "#7059ef",
        "productPriceTextSize": "10px",
        "productPriceWeight": "400",
        "productPriceColor": "#000000",
        "isHeartIcon": false,
        "heartIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
        "heartIconBackgroundColor": "#F0EEFB",
        "heartIconColor": "#F0EEFB",
        "selectedHeartIconColor": "#ff0000",
        "heartIconWidth": "20px",
        "isDiscountIcon": false,
        "discountIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
        "discountIconBackgroundColor": "#F0EEFB",
        "discountIconColor": "#F0EEFB",
        "discountIconWidth": "20px",
        "isCartIcon": false,
        "cartIcon": "https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png",
        "cartIconBackgroundColor": "#F0EEFB",
        "cartIconColor": "#F0EEFB",
        "cartIconWidth": "20px",
        "iconTextSize": "10px"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Product_List_2.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "ProductList_3",
      "name": "ProductList_3",
      "type": "ProductList",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {},
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Product_List_3.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    }
  ]
}

 export default ProductList